import React, { Component } from 'react';
import './App.css';
import firebase from 'firebase';
import FileUploader from 'react-firebase-file-uploader';

// UI framework component imports
import Select from 'muicss/lib/react/select';
import Option from 'muicss/lib/react/option';
import Button from 'muicss/lib/react/button';

export default class AddDrinkItem extends Component {

  // This component doesn't use any properties

  constructor(props) {
    super(props);
    this.state = {
      elValidator_visible: false,
      fieldName: '',
      textareaDescription: '',
      fieldPrice: '',
      pickerType: '',
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  componentDidUpdate() {
  }

  componentWillReceiveProps(nextProps) {
  }

  textInputChanged_fieldName = (event) => {
    this.setState({fieldName: event.target.value});
  }
  
  textAreaChanged_textareaDescription = (event) => {
    this.setState({textareaDescription: event.target.value});
  }
  
  textInputChanged_fieldPrice = (event) => {
    this.setState({fieldPrice: event.target.value});
  }
  
  pickerValueChanged_pickerType = (event) => {
    this.setState({pickerType: event.target.value});
  }
  
  onClick_elButton = (ev) => {
    // Perform action 'Validate' on element 'validator'
    const items = [
    ];
    
    let valid = true;
    for (let i = 0; i < items.length; ++i) {
      let item = items[i];
      valid &= item.result;
      if ( !valid) {
        break;
      }
    };
    this.setState({elValidator_visible: !valid});
    
    if ( !valid) {
      return;
    }
  
    this.sendData_button_to_drinks();
  
    this.props.appActions.updateDataSlot('ds_SlotUploadedImagePath', "");
  
    // Go to screen 'My drinks'
    this.props.appActions.goToScreen('mydrinks', { transitionId: 'fadeIn' });
  
  }
  
  
  sendData_button_to_drinks = () => {
    const dataSheet = this.props.appActions.getDataSheet('drinks');
  
    let row = this.props.dataSheetRow || {
    };
    row = { ...row, 
      description: this.state.textareaDescription,
      drinkName: this.state.fieldName,
      type: this.state.pickerType,
      price: this.state.fieldPrice,
      image_path: (this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_SlotUploadedImagePath'] : ''),
      thumbnail_path: (this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_SlotUploadedImagePath'] : ''),
    };
    if (this.props.dataSheetId === dataSheet.id) {
      this.props.appActions.updateInDataSheet('drinks', row);
    } else {
      this.props.appActions.addToDataSheet('drinks', row);
    }
  }
  
  
  render() {
    const style_elBackground = {
      width: '100%',
      height: '100%',
     };
    const style_elBackground_outer = {
      backgroundColor: 'rgba(0, 0, 0, 0.0752)',
      padding: '2.0px',
     };
    const style_elValidator = {
      color: '#ff2600',
      textAlign: 'left',
     };
    const elValidator = this.state.elValidator_visible ? (
      <div className="elValidator">
        <div className="baseFont" style={style_elValidator}>
          <div>{this.props.locStrings.adddrink_validator_677896}</div>
        </div>
      </div>
      
     ) : null;
    
    const style_elFieldName = {
      display: 'block',
      backgroundColor: 'white',
      paddingLeft: '1rem',
      boxSizing: 'border-box', // ensures padding won't expand element's outer size
      pointerEvents: 'auto',
     };
    
    const style_elTextareaDescription = {
      display: 'block',
      backgroundColor: 'white',
      borderColor: 'lightGray',
      paddingLeft: '1rem',
      boxSizing: 'border-box', // ensures padding won't expand element's outer size
      pointerEvents: 'auto',
     };
    
    const style_elFieldPrice = {
      display: 'block',
      backgroundColor: 'white',
      paddingLeft: '1rem',
      boxSizing: 'border-box', // ensures padding won't expand element's outer size
      pointerEvents: 'auto',
     };
    
    let selection_pickerType = this.state.pickerType;
    // Source datasheet and selected data column for picker element 'pickerType'
    const dataSource_pickerType = this.props.appActions.getDataSheet('types');
    const valueColumnName_pickerType = 'drinkType';
    const labelColumnName_pickerType = 'drinkType';
    
    const style_elPickerType = {
      pointerEvents: 'auto',
     };
    const style_elFirebaseUpload = {
      pointerEvents: 'auto',
     };
    const style_elButton = {
      display: 'block',
      color: 'white',
      textAlign: 'center',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    
    let cssClass_progress = 'circularProgressIndicator';
    if (this.props.appActions.isLoading()) 
      cssClass_progress += ' circularProgressIndicator-active';
    
    
    return (
      <div className="AddDrinkItem">
        <div className="background">
          <div className="containerMinHeight elBackground" style={style_elBackground_outer}>
            <div style={style_elBackground} />
          </div>
        </div>
        
        <div className="layoutFlow">
          { elValidator }
          <div className="elFieldName">
            <input className="baseFont" style={style_elFieldName} type="text" placeholder={this.props.locStrings.adddrink_field_521192} onChange={this.textInputChanged_fieldName} value={this.state.fieldName}  />
          </div>
          
          <div className="elTextareaDescription">
            <textarea className="baseFont" style={style_elTextareaDescription}  placeholder={this.props.locStrings.adddrink_textarea_810693} onChange={this.textAreaChanged_textareaDescription} value={this.state.textareaDescription}  />
          </div>
          
          <div className="elFieldPrice">
            <input className="baseFont" style={style_elFieldPrice} type="number" placeholder={this.props.locStrings.adddrink_fieldcopy_427507} onChange={this.textInputChanged_fieldPrice} value={this.state.fieldPrice}  />
          </div>
          
          <div className="elPickerType">
            <Select className="baseFont" style={style_elPickerType}  onChange={this.pickerValueChanged_pickerType} value={selection_pickerType} >
              {dataSource_pickerType.items.every(item => {
                return item[valueColumnName_pickerType] !== selection_pickerType;
              }) ? <Option value=''/> : null}
              {dataSource_pickerType.items.map(item => {
                const colValue = item[valueColumnName_pickerType];
                const labelColValue = item[labelColumnName_pickerType];
                return <Option key={item.key} value={colValue} label={labelColValue} />
              })}
            </Select>
          </div>
          
          <div className="elFirebaseUpload">
            <div style={style_elFirebaseUpload}>
              <FileUploader
                accept="image/*"
                randomizeFilename
                storageRef={firebase.storage().ref((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_SlotDefaultFolder'] : ''))}
                onUploadStart={() => {
                  this.props.appActions.setState({loading: true});
                }}
                onUploadError={error => {
                  this.props.appActions.setState({loading: false});
                  console.error('** Firebase upload failed: ', error);
                }}
                onUploadSuccess={filename => {
                  this.props.appActions.setState({loading: false});
                  firebase.storage().ref((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_SlotDefaultFolder'] : '')).child(filename).getDownloadURL().then(url => {
                    let setDataSlotValue = (v) => { this.props.appActions.updateDataSlot("ds_SlotUploadedImagePath", v) };
                    setDataSlotValue(url);
                    let setfilenameDataSlotValue = (v) => { this.props.appActions.updateDataSlot("", v) };
                    setfilenameDataSlotValue(filename);
                  }).catch(function(error) {
                    console.error('** Firebase upload failed: ', error);
                  });
                }}
                />
            </div>
          </div>
          
          <div className="elButton">
            <Button className="actionFont" style={style_elButton}  color="accent" onClick={this.onClick_elButton} >
              {this.props.locStrings.adddrink_button_713859}
            </Button>
          </div>
          
          <div className="elSpacer">
            <div />
          </div>
        </div>
        
        <div className="foreground">
          <div className="elProgress">
            <svg className={cssClass_progress}>
              <circle className="circularProgress-animatedPath" style={{stroke: '#0093d5'}} cx="25" cy="25" r="17" fill="none" strokeWidth="3" strokeMiterlimit="10" />
            </svg>
            {this.props.appActions.isLoading() ? <div className='blockInputOverlay' /> : null}
          </div>
        </div>
      </div>
    )
  }
  
}
